import { getUUID, getPhone } from './auth'
import CryptoJS from 'crypto-js/crypto-js'
import md5 from 'js-md5'

/**
 * AES加密
 */
export const AESEncrypt = (str, key) => {
  const uuid = getUUID()
  const phone = getPhone()

  let _key = key || '7C505D4821669080850D33CE31AE6333'
  const __key = CryptoJS.enc.Utf8.parse(_key) //将秘钥转换成Utf8字节数组
  // const iv = CryptoJS.enc.Utf8.parse(_key.substr(0, 16))
  //加密
  const encrypt = CryptoJS.AES.encrypt(JSON.stringify(str), __key, {
    // iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  console.log('AESEncrypt ', uuid, phone, encrypt.toString())
  return encrypt.toString()
}

/**
 * AES解密密
 */
export const AESDecrypt = (str, key) => {
  const uuid = getUUID()
  const phone = getPhone()

  let _key = key || md5(uuid + '-' + phone).toUpperCase()
  const __key = CryptoJS.enc.Utf8.parse(_key) //将秘钥转换成Utf8字节数组

  const decrypt = CryptoJS.AES.decrypt(str, __key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  // const _decrypt = JSON.parse(decrypt.toString(CryptoJS.enc.Utf8)) //解密后的数据
  const _decrypt = decrypt.toString(CryptoJS.enc.Utf8) //解密后的数据
  return _decrypt
}



// WEBPACK FOOTER //
// ./src/common/myaes.js